import { Grid, Link, Stack, Typography } from 'ui';

export const ErrorPage = ({ href, message = 'Something went wrong!' }: { href: string; message?: string }) => {
  return (
    <Grid display="flex" justifyContent="center" alignItems="center" mt={20}>
      <Grid container direction="column" display="flex" alignItems="center">
        <Typography variant="h1">Error</Typography>
        <Stack direction="row" spacing="2">
          <Typography>{message}</Typography>
        </Stack>
        <Link href={href}>Back Home</Link>
      </Grid>
    </Grid>
  );
};
